import api from '@/utils/api';

const controller = 'v1.0/EventoCallback';
const reprocessarCallbackExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        ReprocessarCallback: function (model) {
            return api.Axios.Post(`${controller}/Reprocessar`, model);
        },
        GetByFilter: function (model) {
            return api.Axios.GetParams(controller, model);
        }
    }
);

export default reprocessarCallbackExport;